import { useState, useEffect } from 'react';
import JsBarcode from "jsbarcode";



// const BarcodeGenerator = ({ barcodeDataArray, option }) => {
//     const [barcodeImages, setBarcodeImages] = useState([]);

//     const generateBarcodes = () => {
//         const images = barcodeDataArray.map((data) => {
//             const canvas = document.createElement("canvas");
//             JsBarcode(canvas, data, option);
//             return canvas.toDataURL();
//         });
//         setBarcodeImages(images);
//     };

//     return (
//         <div className="flex flex-col items-center mx-auto justify-center">
//             <button
//                 onClick={generateBarcodes}
//                 className="mb-4 border rounded-md p-2 hover:bg-cyan-300"
//             >
//                 Generate Barcodes
//             </button>
//             {barcodeImages.map((barcodeImage, index) => (
//                 <div
//                     key={index}
//                     className="flex items-center justify-center mt-4"
//                 >
//                     <img
//                         src={barcodeImage}
//                         alt={`Barcode ${index + 1}`}
//                         className="border"
//                     />
//                     <a
//                         href={barcodeImage}
//                         download={`barcode_${index + 1}.png`}
//                         className="ml-8 border rounded-md p-2 hover:bg-cyan-300"
//                     >
//                         Download
//                     </a>
//                 </div>
//             ))}
//         </div>
//     );
// };

// Example usage
// const barcodeDataArray = ["123456789", "987654321", "567890123"];
// const options = {
//     format: "CODE128",
//     width: 2,
//     height: 100,
//     displayValue: true,
// };

export default function BarGen() {
    // const [data, setData] = useState([]);
    const [barformat, setBarFomat] = useState('CODE128');
    const [msg, setMsg] = useState('');
    const [txt,  setTxt] = useState("freelance.in.th");
    const [barcodeImages, setBarcodeImages] = useState([]);


    // useEffect(() => {
        const option = {
            width: 2,
            height: 80,
            format: barformat,
            displayValue: true,
            fontOptions: "",
            font: "monospace",
            textAlign: "center",
            textPosition: "bottom",
            textMargin: 2,
            fontSize: 20,
            background: "#ffffff",
            lineColor: "#000000",
            margin: 10,
            marginTop: undefined,
            marginBottom: undefined,
            marginLeft: undefined,
            marginRight: undefined,
            id: "mybarcode",
            className: undefined,
            valid:	function(valid){
                if(!valid) {
                    setMsg('This type is not valid!!!');
                } else {setMsg(''); }
            }
        }
        
    
    // }, [barformat]);

    const generateBarcodes = (data) => {
        const images = data.map((data) => {
            const canvas = document.createElement("canvas");
            JsBarcode(canvas, data, option);
            return canvas.toDataURL();
        });
        setBarcodeImages(images);
    };


    const handleTxtChange = (e) => {
        setTxt(e.target.value)

    }
    const handleTypeChange = (e) => {
        setBarFomat(e.target.value)
    }

    function handleSubmit(e) {
        // Prevent the browser from reloading the page
        e.preventDefault();
       
        // console.log(txt);
        // Read the form data
        // const form = e.target;
        // const formData = new FormData(form);
        // console.log(formData);
        // You can pass formData as a fetch body directly:
        // fetch('/some-api', { method: form.method, body: formData });

        // Or you can work with it as a plain object:
        // const formJson = Object.fromEntries(formData.entries());
        // console.log(formJson);
        const lines = txt.split("\n");
        // console.log(lines);
        // setData(lines);

        if(lines?.length>0) {
            generateBarcodes(lines);
        }

        
    }   
    
    return (
        <div className="App">
            <h1 className="text-center mb-4 bg-slate-300">Barcode Generator</h1>
            <form method="post" onSubmit={handleSubmit}>
                <label className="flex flex-col sm:flex-row justify-center text-sm">
                    <div className="grid">
                        <p>Barcode Data:</p>
                        <p>*1Line/Data*</p>

                    </div>
                    <textarea
                        name="barcodeData"
                        // defaultValue="freelance.in.th"
                        value={txt}
                        rows={4}
                        cols={40}
                        onChange={handleTxtChange}
                        className="text-sm pl-2 ml-2 border rounded-r-md focus:outline-none ring-inset focus:ring focus:border-blue-500" 
                    />
                    
                    <div className="flex flex-col text-sm py-2 sm:py-0 px-2 gap-1 justify-center ">
                        <div>
                            <select 
                                className="text-md sm:text-sm text-center border rounded-r-md focus:outline-none ring-inset focus:ring focus:border-blue-500" 
                                id="barcodeType" 
                                title="CODE128" 
                                onChange={handleTypeChange}
                            >
                                <option value="CODE128">CODE128 auto</option>
                                <option value="CODE128A">CODE128 A</option>
                                <option value="CODE128B">CODE128 B</option>
                                <option value="CODE128C">CODE128 C</option>
                                <option value="EAN13">EAN13</option>
                                <option value="EAN8">EAN8</option>
                                <option value="UPC">UPC</option>
                                <option value="CODE39">CODE39</option>
                                <option value="ITF14">ITF14</option>
                                <option value="ITF">ITF</option>
                                <option value="MSI">MSI</option>
                                <option value="MSI10">MSI10</option>
                                <option value="MSI11">MSI11</option>
                                <option value="MSI1010">MSI1010</option>
                                <option value="MSI1110">MSI1110</option>
                                <option value="pharmacode">Pharmacode</option>
                            </select>
                        </div> 
                        <button type="reset" className="p-2 text-white text-sm rounded-md bg-slate-500 hover:bg-slate-400">Reset</button>
                        <button type="submit" className="p-2 text-white text-sm rounded-md bg-blue-700 hover:bg-blue-400">GenBarcode</button>
                    </div>
                </label>
                <hr />
            </form>
            <p className="text-red-500 text-center">{msg}</p>
            <div className="flex flex-col items-center mx-auto justify-center">
                {/* <button
                    onClick={generateBarcodes}
                    className="mb-4 border rounded-md p-2 hover:bg-cyan-300"
                >
                    Generate Barcodes
                </button> */}
                {msg===""&&barcodeImages.map((barcodeImage, index) => (
                    <div
                        key={index}
                        className="flex items-center justify-center mt-4"
                    >
                        <img
                            src={barcodeImage}
                            alt={`Barcode ${index + 1}`}
                            className="border"
                        />
                        <a
                            href={barcodeImage}
                            download={`barcode_${index + 1}.png`}
                            className="ml-4 border rounded-md p-2 hover:bg-cyan-300"
                        >
                            Download
                        </a>
                    </div>
                ))}
            </div>    


            {/* <BarcodeGenerator barcodeDataArray={barcodeDataArray} options={options} /> */}
        </div>
    );
}
